<app-loading [isLoading]="!progressService.selectedFestival()">
  <div class="p-4 flex flex-col gap-4">
    <h1 class="text-2xl leading-snug">Datumsauswahl</h1>
    <p>Wählen Sie einen Termin für Ihre Reservierung
      beim {{ progressService.selectedFestival()!.title_public }}.</p>
    <div class="bg-white rounded-lg p-2" role="group" aria-label="Kalender für Datumsauswahl">
      <div class="text-sm font-semibold text-benzGrey-900 mb-3" aria-live="polite">
        Vom {{ progressService.selectedFestival()!.valid_from_date | date:'dd. MMMM' }}
        bis {{ progressService.selectedFestival()!.valid_to_date | date:'dd. MMMM yyyy' }}
      </div>
      <div class="grid grid-cols-7 gap-y-4 gap-x-1 text-center mt-2 justify-center" role="grid" aria-label="Kalenderansicht">
        <abbr title="Montag" class="no-underline">Mo</abbr>
        <abbr title="Dienstag" class="no-underline">Di</abbr>
        <abbr title="Mittwoch" class="no-underline">Mi</abbr>
        <abbr title="Donnerstag" class="no-underline">Do</abbr>
        <abbr title="Freitag" class="no-underline">Fr</abbr>
        <abbr title="Samstag" class="no-underline">Sa</abbr>
        <abbr title="Sonntag" class="no-underline">So</abbr>
        <div class="col-span-7 w-full border-[0.5px] border-benzGrey-100" aria-hidden="true"></div>
        <!-- one of: col-span-0 col-span-1 col-span-2 col-span-3 col-span-4 col-span-5 col-span-6 -->
        <div class="col-span-{{firstCalendarDayWeekday()-1}}" aria-hidden="true"></div>
        @for (calendarDay of calendarDays(); track calendarDay.date.getTime()) {
          <div class="flex flex-col items-center" role="gridcell">
            <button type="button"
               [disabled]="calendarDay.availableDaytypes.length === 0"
               [class.hover:bg-benzGrey-150]="calendarDay.availableDaytypes.length > 0"
               [class.text-benzGrey-75]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
               [class.hover:text-benzGrey-900]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
               [class.bg-benzGrey-100]="calendarDay.availableDaytypes.length > 0"
               [class.bg-benzGrey-900]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
               [class.cursor-not-allowed]="calendarDay.availableDaytypes.length === 0"
               [class.opacity-50]="calendarDay.availableDaytypes.length === 0"
               (click)="selectDay(calendarDay)"
               [attr.aria-label]="(calendarDay.date | date:'EEEE, dd. MMMM yyyy':'UTC') + (calendarDay.availableDaytypes.length > 0 ? ', verfügbar' : ', nicht verfügbar')"
               [attr.aria-pressed]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
               class="w-10 h-10 flex justify-center items-center rounded-full relative focus:outline-none focus:ring-2 focus:ring-benzRed-700">{{ calendarDay.date.getUTCDate() }}</button>
            <span class="text-sm my-1" aria-hidden="true">{{ calendarDay.date | date:'MMM':'UTC' | uppercase }}</span>
          </div>
        }
      </div>
    </div>
    @if (availableDayTypesForSelectedDate().length > 0) {
      <div class="flex flex-col gap-4 mt-4" role="region" aria-labelledby="timeslot-heading">
        <h2 id="timeslot-heading" class="text-2xl leading-snug">Zeitfenster</h2>
        <p>Bitte wählen Sie das gewünschte Zeitfenster aus</p>
        <div role="list" aria-label="Verfügbare Zeitfenster">
        @for (daySlot of availableDayTypesForSelectedDate(); track daySlot.type) {
          <button type="button"
            role="listitem"
            [attr.aria-label]="translateDayslot(daySlot.type, availableDayTypesForSelectedDate().length) + ': Von ' + (daySlot.from | date:'HH:mm') + ' bis ' + (daySlot.to | date:'HH:mm') + ' Uhr, ab ' + (daySlot.minCost | currency:'EUR')"
            class="text-left cursor-pointer bg-white rounded-xl p-3 justify-between items-center flex gap-2 border-2 border-benzGrey-900 hover:border-benzGrey-400 focus:outline-none focus:ring-2 focus:ring-benzRed-700 w-full mb-2"
          (click)="selectDayType(daySlot.type)"
          >
            <div class="flex-col gap-2 flex">
            <span class="font-bold">{{ translateDayslot(daySlot.type, availableDayTypesForSelectedDate().length) }}</span>
            <span>Von {{ daySlot.from | date:'HH:mm' }} bis {{ daySlot.to | date:'HH:mm' }} Uhr</span>
            </div>
            <div>
              <span>Ab {{ daySlot.minCost | currency:'EUR' }}</span>
            </div>
          </button>
        }
        </div>
        <span class="pb-4 -mb-4" #endOfSlotList aria-hidden="true"></span>
      </div>
    }
  </div>
</app-loading>

